import React from 'react'; // Removed useState, useMemo, useEffect
import { ChevronLeft, ChevronRight } from 'lucide-react';
// DatePicker and Search are not used directly in this component based on the provided snippet

import { MappingStyles, MappingStatus } from '../../../utils/utils'; // If not used, remove


const ApplicationsTable = ({
  // applications, // Data is now coming via currentTableData
  // filteredApplications, // Data is now coming via currentTableData
  onViewApplication,
  getStatusStyle,
  // Props for displaying paginated data and handling pagination events
  currentTableData,
  totalPages,
  currentPage,
  setCurrentPage, // Function to change the page
  selectedApplicationIds, // Array of selected application IDs
  onSelectApplication,    // Handler for individual row checkbox
  onSelectAllApplications, // Handler for header checkbox
  isAllSelected,          // Boolean to control the header checkbox state
  // ITEMS_PER_PAGE is used by parent to calculate totalPages and currentTableData
}) => {
  // The useEffect for resetting page has been removed.
  // This logic is now handled in StaffProfile.jsx.

  const goToPage = (pageNumber) => {
    if (setCurrentPage) setCurrentPage(pageNumber);
  };
  const goToPreviousPage = () => {
    if (setCurrentPage) setCurrentPage(prev => Math.max(1, prev - 1));
  };
  const goToNextPage = () => {
    if (setCurrentPage && totalPages) setCurrentPage(prev => Math.min(totalPages, prev + 1));
  };

  return (
    <div className="rounded-lg p-4 mb-6">
      <div className="overflow-x-auto scrollbar-hide">
        <table className="w-full text-sm border border-[#333333]">
          <thead className="bg-[#131313] text-left">
            <tr>
              <th className="p-4 border-r border-b border-[#333333]">
                <div className="flex justify-center">
                  <input
                    type="checkbox"
                    className="appearance-none h-5 w-5 border border-white rounded-sm bg-transparent checked:bg-yellow-400 checked:border-yellow-400 checked:appearance-none relative cursor-pointer
                      before:content-['✓'] before:absolute before:text-white before:inset-0 before:flex before:items-center before:justify-center before:text-sm before:font-bold before:opacity-0 checked:before:opacity-100"
                    checked={isAllSelected}
                    onChange={onSelectAllApplications}
                  />
                </div>
              </th>
              <th className="p-4 border-r border-b border-[#333333]">
                <div className="flex justify-center">APPLICATION ID</div>
              </th>
              <th className="p-4 border-r border-b border-[#333333]">
                <div className="flex justify-center">APPLICANT NAME</div>
              </th>
              <th className="p-4 border-r border-b border-[#333333]">
                <div className="flex justify-center">LOAN AMOUNT</div>
              </th>
              <th className="p-4 border-r border-b border-[#333333]">
                <div className="flex justify-center">STATUS</div>
              </th>
              <th className="p-4 border-r border-b border-[#333333]">
                <div className="flex justify-center">DAYS IN PROCESS</div>
              </th>
              <th className="p-4 border-b border-[#333333]">
                <div className="flex justify-center">ACTIONS</div>
              </th>
            </tr>
          </thead>
          <tbody className="bg-[#131313] text-left">
            {(!currentTableData || currentTableData.length === 0) ? (
              <tr>
                <td
                  colSpan="7"
                  className="p-4 text-center text-lg text-gray-400"
                >
                  No applications found matching your criteria.
                </td>
              </tr>
            ) : (
              currentTableData.map((app, index) => ( // Use app._id or a unique key if available instead of index
                <tr key={index}>
                  <td className="p-4 border-r border-b border-[#333333]">
                    <div className="flex justify-center">
                      <input
                        type="checkbox"
                        className="appearance-none h-5 w-5 border border-white rounded-sm bg-transparent checked:bg-yellow-400 checked:border-yellow-400 checked:appearance-none relative cursor-pointer
                          before:content-['✓'] before:absolute before:text-white before:inset-0 before:flex before:items-center before:justify-center before:text-sm before:font-bold before:opacity-0 checked:before:opacity-100"
                        checked={selectedApplicationIds.includes(app._id)}
                        onChange={() => onSelectApplication(app._id)}
                      />
                    </div>
                  </td>
                  <td className="p-4 border-r border-b border-[#333333]">
                    <div className="flex flex-col items-center">
                      <div>{app._id}</div>
                      <div className="text-xs text-gray-400">
                        {new Date(app.createdAt).toLocaleDateString()}
                      </div>
                    </div>
                  </td>
                  <td className="p-4 border-r border-b border-[#333333]">
                    <div className="flex justify-center">
                      {app.user?.name || "N/A"}
                    </div>
                  </td>
                  <td className="p-4 border-r border-b border-[#333333]">
                    <div className="flex flex-col items-center">
                      <div>₹{app.principle}</div>
                      <div className="text-xs text-gray-400">
                        {app.loanType || "N/A"}
                      </div>
                    </div>
                  </td>
                  <td className="p-4 border-r border-b border-[#333333]">
                    <div className="flex justify-center">
                      <span
                        className={`px-3 py-1 rounded-full text-xs ${MappingStyles(
                          app.status
                        )}`}
                      >
                        {MappingStatus(app.status)}
                      </span>
                    </div>
                  </td>
                  <td className="p-4 border-r border-b border-[#333333]">
                    <div className="flex justify-center">
                      {app.processingTime} days
                    </div>
                  </td>
                  <td className="p-2 border-b border-[#333333]">
                    <div className="flex justify-center gap-2">
                      <button
                        onClick={() => onViewApplication(app._id)}
                        className="text-[#FFCA20] underline text-xs hover:none sm:text-sm border-r-2 border-[#979797] pr-2"
                      >
                        View
                      </button>
                      {/* <button className="text-[#FFCA20] hover:underline flex items-center gap-1 text-xs sm:text-sm border-l-4 border-[#9e9e9e] ">
                        <svg
                          width="15"
                          height="10"
                          viewBox="0 0 20 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.7891 0.828125C19.1406 0.984375 19.375 1.33594 19.375 1.6875V7.3125C19.375 7.85938 18.9453 8.25 18.4375 8.25H12.8125C12.4219 8.25 12.0703 8.05469 11.9141 7.70312C11.7969 7.35156 11.875 6.92188 12.1484 6.6875L14.4531 4.34375C13.2422 3.28906 11.6797 2.625 10 2.625C6.95312 2.625 4.21875 4.69531 3.39844 7.58594C3.24219 8.09375 2.73438 8.36719 2.22656 8.25C1.71875 8.09375 1.44531 7.58594 1.5625 7.07812C2.65625 3.36719 6.13281 0.75 10 0.75C12.1875 0.75 14.2188 1.60938 15.7812 3.01562L17.7734 1.0625C18.0078 0.789062 18.4375 0.710938 18.7891 0.828125ZM17.7344 10.7891C18.2422 10.9453 18.5156 11.4531 18.3984 11.9609C17.3047 15.6719 13.8672 18.25 10 18.25C7.77344 18.25 5.74219 17.4297 4.17969 16.0234L2.1875 17.9766C2.03125 18.1719 1.79688 18.25 1.5625 18.25C1.40625 18.25 1.28906 18.25 1.17188 18.2109C0.820312 18.0547 0.625 17.7031 0.625 17.3125V11.6875C0.625 11.1797 1.01562 10.75 1.5625 10.75H7.1875C7.53906 10.75 7.89062 10.9844 8.04688 11.3359C8.16406 11.6875 8.08594 12.1172 7.8125 12.3516L5.50781 14.6953C6.71875 15.75 8.28125 16.375 10 16.375C13.0078 16.375 15.7422 14.3438 16.6016 11.4531C16.7188 10.9453 17.2656 10.6719 17.7344 10.7891Z"
                            fill="#FFCA20"
                          />
                        </svg>
                        <span className="text-vs">Re-Assign Applicant</span>
                      </button> */}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {totalPages && totalPages > 1 && (
        <div className="flex items-center justify-center gap-2 mt-6 mb-4">
          <button
            onClick={() => goToPage(1)}
            disabled={currentPage === 1}
            className="flex items-center text-sm text-gray-400 hover:text-white disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <ChevronLeft size={16} className="mr-1" />
            First Page
          </button>
          <div className="flex gap-1">
            {Array.from({ length: totalPages }, (_, i) => i + 1).map(
              (pageNumber) => (
                <button
                  key={pageNumber}
                  onClick={() => goToPage(pageNumber)}
                  className={`w-8 h-8 flex items-center justify-center rounded text-sm ${
                    currentPage === pageNumber
                      ? "bg-[#FFCA20] text-black font-medium" // Changed from font-semibold
                      : "bg-gray-800 text-white hover:bg-gray-700" // Changed background and text color
                  }`}
                >
                  {pageNumber}
                </button>
              )
            )}
          </div>
          <button
            onClick={() => goToPage(totalPages)}
            disabled={currentPage === totalPages}
            className="flex items-center text-sm text-gray-400 hover:text-white disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Last Page
            <ChevronRight size={16} className="ml-1" />
          </button>
        </div>
      )}
    </div>
  );
};

export default ApplicationsTable;
